import React from "react";
import styled from "@emotion/styled";
import AccountBadge from "../AccountBadge";
import ConnectButton from "../ConnectButton";

const Header = () => {
  return (
    <TurfHeader>
      <h1>Turf Town</h1>
      <AccountBadge />
      <ConnectButton />
    </TurfHeader>
  );
};

const TurfHeader = styled.div`
  background: #f2c24e;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  padding: 1em 2em;
`;

export default Header;
